// Keep this module dependency-free: it is reached from *.testIds files that the
// Playwright suite imports, and the E2E runner has no frontend node_modules.
const getSlugValue = (slug: string | null | undefined): string => slug?.toLowerCase()?.replace(/\s/g, '-') ?? '';

export default getSlugValue;
